export default __webpack_public_path__ + "static/media/swimming-pool.be51957e.png";